module.exports = __webpack_public_path__ + "img/failed_button.39b8fac1.jpg";